interface Props {
	iconColor?: string;
	width?: string;
	height?: string;
}

const HomeIcon = ({ iconColor = 'currentColor', width = '24', height = '24' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
		<path
			d="M4 10.75L12 4.5L20 10.75V19C20 19.5523 19.5523 20 19 20H15V14H9V20H5C4.44772 20 4 19.5523 4 19V10.75Z"
			stroke={iconColor}
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default HomeIcon;
